"use strict";

var defaultVars = {
  version: "0.1.0.20200825203613",
  SERVER_API: "https://news-api.go-connect.com",
};

module.exports = { defaultVars };